<template>
    <div class="kgr-row">
        <div>
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                <div class="kgr-postfix__fluid">
                    <a
                        :href="overviewUrl"
                        class="kgr-button kgr-button--link"
                    >
                        <kgr-icon
                            icon-class="arrow-left"
                            class="kgr-button__icon kgr-button__icon--left"
                        />

                        <span v-t="'backToOverview'"></span>
                    </a>
                    <kgr-view-picker
                        :value="view"
                        @post-input="updateView"
                    />
                </div>
                <div
                    v-if="canCreateNew"
                    class="kgr-postfix__fixed"
                >
                    <a
                        class="kgr-button kgr-button--accent"
                        :href="createUrl"
                    >
                        <kgr-icon
                            icon-class="add"
                            small
                            circle
                            highlight
                            class="kgr-button__icon kgr-button__icon--left"
                        />
                        <span v-t="'field.create'"></span>
                    </a>
                </div>
                <div class="kgr-postfix__fixed">
                    <kgr-print-button />
                </div>
            </div>

            <div class="kgr-grid kgr-grid--inline kgr-grid--gutters kgr-row">
                <div class="kgr-grid__cell">
                    <label class="kgr-inputGroup">
                        <div
                            v-t="'search'"
                            class="kgr-inputGroup__label"
                        ></div>
                        <input
                            v-model="filter"
                            type="text"
                            class="kgr-input"
                        />
                    </label>
                </div>
            </div>
        </div>
        <div>
            <kgr-field-list
                :fields="fields"
                :filter="filter"
                :view="view"
            />
        </div>
    </div>
</template>

<script>
import FieldRepository from '../../js/repository/FieldRepository';
import Icon from '../../components/common/icon/Icon';
import KgrFieldList from '../../components/resource/FieldList';
import PrintButton from '../../components/common/form/button/PrintButton';
import ViewPicker from '../../components/common/form/picker/ViewPicker';

const FIELDS_OVERVIEW_VIEW = 'kgr:fields:overview:view';

export default {
    components: {
        KgrFieldList,
        'kgr-print-button': PrintButton,
        'kgr-view-picker': ViewPicker,
        'kgr-icon': Icon,
    },
    props: {
        areaId: {
            type: String,
            required: true,
        },
        locationId: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
        createUrl: {
            type: String,
            required: true,
        },
        canCreateNew: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            filter: null,
            fields: [],
            view: 'grid'
        };
    },
    created() {
        const view = localStorage.getItem(FIELDS_OVERVIEW_VIEW);
        if (null !== view && '' !== view) {
            this.view = view;
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        updateView(view) {
            this.view = view;

            if (null !== view) {
                localStorage.setItem(FIELDS_OVERVIEW_VIEW, view);
            } else {
                localStorage.removeItem(FIELDS_OVERVIEW_VIEW);
            }
        },
        load() {
            FieldRepository.findAllByLocationIdAndAreaId(this.locationId, this.areaId)
                .then(fields => this.fields = fields)
                .catch(() => this.$notify.error('error.loadingData'));
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
